<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>Laporan Produk Terlaris</h2>

      <br />

      <div class="filter">
        <div class="form-group">
          <label for="">Filter Tanggal</label>
          <date-range-picker v-model="dateRange">
            <template v-slot:input="picker">
              {{ moment(picker.startDate).format("DD MMM YYYY") }} -
              {{ moment(picker.endDate).format("DD MMM YYYY") }}
            </template>
          </date-range-picker>
        </div>
        <div class="form-group">
          <label>&nbsp;</label>
          <button type="button" class="btn-fill">Filter</button>
        </div>
        <div class="form-group"></div>
        <div class="form-group"></div>
        <div class="form-group">
          <label>Export Data</label>
          <button type="button" class="btn-outline">Export CSV</button>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Produk</th>
            <th>Harga Jual</th>
            <th>Harga Modal</th>
            <th>Jumlah Terjual</th>
            <th>Total Penjualan</th>
            <th>Laba</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.nama }}</td>
            <td>Rp {{ item.harga_jual | number }}</td>
            <td>Rp {{ item.harga_modal | number }}</td>
            <td>{{ item.jumlah | number }}</td>
            <td>Rp {{ calculatePenjualan(item) | number }}</td>
            <td>Rp {{ calculateLaba(item) | number }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

import * as api from "./../../api/Api";
import moment from "moment";

export default {
  name: "Home",
  components: {
    DateRangePicker,
  },
  data() {
    return {
      loading: false,
      data: [],
      dateRange: {
        startDate: moment().format("YYYY-MM-01"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      filter: {
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-D"),
        metode_bayar: "SEMUA",
      },
    };
  },
  methods: {
    moment,
    loadData() {
      this.loading = true;

      this.filter.id_toko = this.$toko.id;
      this.filter.tgl_awal = moment(this.dateRange.startDate).format(
        "YYYY-MM-DD"
      );
      this.filter.tgl_akhir = moment(this.dateRange.endDate).format(
        "YYYY-MM-DD"
      );

      api
        .get("/v1/laporan/produk-terlaris?" + this.$objectToQuery(this.filter))
        .then((r) => {
          this.loading = false;
          this.data = r.data;
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    calculatePenjualan(item) {
      return item.jumlah * item.harga_jual;
    },
    calculateLaba(item) {
      const laba = item.harga_jual - item.harga_modal;
      return item.jumlah * laba;
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .filter {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 20px;
    margin-bottom: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/laporan/ProdukTerlaris.vue